module.exports = __webpack_public_path__ + "img/industry2_m.77c1842e.jpg";